import { Outlet } from 'react-router-dom';
import { useStudentTheme } from '@/hooks/useStudentTheme';

export function LessonLayout() {
  useStudentTheme();

  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  );
}
